'use client';
import styles from './SectionWithPlayAll.module.css';
import { useAudioPlayer } from '@/context/AudioPlayerContext';

export default function SectionWithPlayAll({
  title,
  playlists = [],
  songs = [],
  children,
  titleClassName = '',
}) {
  const { playTracks } = useAudioPlayer();

  // Универсальная функция разворачивания любого элемента в песни
  const extractTracks = (items = []) =>
    items.flatMap(item => {
      if (!item) return [];

      // Песня
      if (item.type === 'song' || item._type === 'song') {
        return [{
          ...item,
          slug: item.slug,
          audioUrl: `/api/audio/${item.slug}/${item.slug}.m3u8`,
        }];
      }

      // Work
      if (item.type === 'work' || item._type === 'work') {
        if (Array.isArray(item.song) && item.song.length) {
          return item.song.map(s => ({
            ...s,
            slug: s.slug,
            audioUrl: `/api/audio/${s.slug}/${s.slug}.m3u8`,
          }));
        }
        if (Array.isArray(item.playlisttrack) && item.playlisttrack.length) {
          return item.playlisttrack.map(pt => ({
            ...pt.song,
            slug: pt.song.slug,
            audioUrl: `/api/audio/${pt.song.slug}/${pt.song.slug}.m3u8`,
          }));
        }
      }

      // Playlist и UserPlaylist
      if (
        item.type === 'playlist' || item._type === 'playlist' ||
        item.type === 'userplaylist' || item._type === 'userplaylist'
      ) {
        if (Array.isArray(item.playlisttrack) && item.playlisttrack.length) {
          return item.playlisttrack.map(pt => ({
            ...pt.song,
            slug: pt.song.slug,
            audioUrl: `/api/audio/${pt.song.slug}/${pt.song.slug}.m3u8`,
          }));
        }
        if (Array.isArray(item.tracks) && item.tracks.length) {
          return item.tracks.map(t => ({
            ...t.song,
            slug: t.song.slug,
            audioUrl: `/api/audio/${t.song.slug}/${t.song.slug}.m3u8`,
          }));
        }
        if (Array.isArray(item.song) && item.song.length) {
          return item.song.map(s => ({
            ...s,
            slug: s.slug,
            audioUrl: `/api/audio/${s.slug}/${s.slug}.m3u8`,
          }));
        }
      }

      return [];
    }).filter(Boolean);

  // Добавляем уникальный идентификатор позиции
  const addInstanceIds = (tracks) =>
    tracks.map((track, index) => ({
      ...track,
      _instanceId: `${track.id || 'noid'}-${index}`
    }));

  const handlePlayAll = () => {
    // Собираем треки из всех источников
    const allItems = [...playlists, ...songs];
    const allTracks = extractTracks(allItems);
    const songsWithInstanceIds = addInstanceIds(allTracks);

    playTracks(songsWithInstanceIds);
  };

  return (
    <section className={styles.sliderSection}>
      <div className={styles.sectionHeader}>
        <h2 className={`${styles.sectionTitle} ${titleClassName}`}>{title}</h2>
        <button className={styles.playAllButton} onClick={handlePlayAll}>
          Play All
        </button>
      </div>
      <div className={styles.slider}>{children}</div>
    </section>
  );
}
